import {useDrop} from "react-dnd";

const DropContainer = (props) => {
  const [{isOver}, cardDrop] = useDrop(() => ({
    accept: props.accepts, drop: props.onDrop, collect: (monitor) => ({
      isOver: monitor.isOver(), canDrop: monitor.canDrop()
    })
  }), ['dragCard', props.onDrop]);

  return <div style={{...props.style, marginLeft: !props.noML && isOver ? "10px" : 0}} ref={cardDrop}
              className={"buffer-container" + (isOver ? " droppable" : "")}>{props.content}</div>
}

export default DropContainer;
